import o from "react";
import { cls as O } from "../../helpers/cls.js";
import { useWindowSize as b } from "../../hooks/useWindowSize.js";
import { useUniqueId as g } from "../../hooks/useUniqueId.js";
import "../Badge/Badge.js";
import "@olxbr/ds-icons";
import "../Text/Text.js";
import "./components/LinkWrapper/index.js";
import "./components/Title/index.js";
import { AdCardHead as h } from "./components/AdCardHead/index.js";
import { AdCardBody as y } from "./components/AdCardBody/index.js";
import { AdCardFooter as E } from "./components/AdCardFooter/index.js";
var C = Object.defineProperty,
  v = Object.defineProperties,
  I = Object.getOwnPropertyDescriptors,
  n = Object.getOwnPropertySymbols,
  A = Object.prototype.hasOwnProperty,
  D = Object.prototype.propertyIsEnumerable,
  s = (e, r, t) => r in e ? C(e, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : e[r] = t,
  i = (e, r) => {
    for (var t in r || (r = {})) A.call(r, t) && s(e, t, r[t]);
    if (n) for (var t of n(r)) D.call(r, t) && s(e, t, r[t]);
    return e;
  },
  l = (e, r) => v(e, I(r));
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const p = e => {
  const {
      mode: r = "horizontal",
      isSlimCard: t = !1,
      showImageBlurBackground: f = !1,
      isHighlight: u,
      className: S,
      forceSmallScreenLayout: _
    } = e,
    {
      width: m
    } = b(),
    d = m < 566,
    w = d || _,
    a = r === "vertical" && t,
    c = g("ds-ad-card-title");
  return o.createElement("section", {
    "data-ds-component": "DS-AdCard",
    className: O("olx-ad-card", "olx-ad-card--".concat(r), u && "olx-ad-card--highlight", a && "olx-ad-card--vertical-slim", S)
  }, o.createElement(h, l(i({}, e), {
    titleID: c,
    isSmallScreen: w,
    showImageBlurBackground: f
  })), o.createElement(y, l(i({}, e), {
    titleID: c,
    isVerticalSlimCard: a,
    isMobile: d,
    width: m
  })), o.createElement(E, l(i({}, e), {
    isVerticalSlimCard: a
  })));
};
p.displayName = "AdCard";
export { p as AdCard };